import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const Laboratory = () => {
    useEffect(() => {
        document.title = 'Laboratory -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>Laboratory</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Laboratory </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                <p> Learning through hands is a potent way and this facility is provided by well- equipped laboratories in Physics, Chemistry, Biology, Computer Science, Aero-Modelling, Home science and Maths. </p>

                <p> We have 2 labs each for Physics, Chemistry and Biology. </p>
                </div>
                <div className="col-lg-3">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div>
                <div className="col-lg-3">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div>
               <div className="col-lg-3">
               <LazyLoad>
               <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
             </LazyLoad>  
              </div>
              <div className="col-lg-3">
              <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory3.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory3.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
            </LazyLoad>  
             </div>
             <div className="col-lg-3">
             <LazyLoad>
             <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory4.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory4.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
           </LazyLoad>  
            </div>
            <div className="col-lg-3">
            <LazyLoad>
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory5.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Laboratory5.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
          </LazyLoad>  
           </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default Laboratory